import { render, staticRenderFns } from "./CourseDetail.vue?vue&type=template&id=4648f74a&scoped=true"
import script from "./CourseDetail.vue?vue&type=script&lang=js"
export * from "./CourseDetail.vue?vue&type=script&lang=js"
import style0 from "./CourseDetail.vue?vue&type=style&index=0&id=4648f74a&prod&scoped=true&lang=css"
import style1 from "./CourseDetail.vue?vue&type=style&index=1&id=4648f74a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4648f74a",
  null
  
)

export default component.exports